export default __webpack_public_path__ + "static/media/Android.c717c700.svg";